export const DeploymentTopologyDiagram = () => (
  <div className="diagram-wrap">
    <svg
      viewBox="0 0 960 360"
      role="img"
      aria-label="Three deployment modes: on-prem, bank cloud, and Bancony SaaS"
    >
      <defs>
        <linearGradient id="boundary" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#38B6FF" stopOpacity="0.0" />
          <stop offset="50%" stopColor="#38B6FF" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#38B6FF" stopOpacity="0.0" />
        </linearGradient>
        <pattern id="dotted" width="6" height="6" patternUnits="userSpaceOnUse">
          <circle cx="3" cy="3" r="1.2" fill="#9aa8bb" />
        </pattern>
      </defs>

      {/* Column titles */}
      <text x="160" y="40" textAnchor="middle" fontFamily="Raleway" fontWeight="700" fontSize="14" fill="#0b1929">ON-PREM</text>
      <text x="480" y="40" textAnchor="middle" fontFamily="Raleway" fontWeight="700" fontSize="14" fill="#0b1929">BANK CLOUD</text>
      <text x="800" y="40" textAnchor="middle" fontFamily="Raleway" fontWeight="700" fontSize="14" fill="#0b1929">BANCONY SAAS</text>

      {/* Boundary rectangles (bank perimeter) */}
      <rect x="40" y="60" width="240" height="260" rx="14" fill="#fff" stroke="#cdd6e3" strokeDasharray="4 4" />
      <rect x="360" y="60" width="240" height="260" rx="14" fill="#fff" stroke="#cdd6e3" strokeDasharray="4 4" />
      <rect x="680" y="60" width="240" height="260" rx="14" fill="#f6f9fc" stroke="#cdd6e3" />

      <text x="160" y="80" textAnchor="middle" fontFamily="Raleway" fontWeight="600" fontSize="11" fill="#777">Bank perimeter</text>
      <text x="480" y="80" textAnchor="middle" fontFamily="Raleway" fontWeight="600" fontSize="11" fill="#777">Bank-owned cloud tenancy</text>
      <text x="800" y="80" textAnchor="middle" fontFamily="Raleway" fontWeight="600" fontSize="11" fill="#777">Bancony EU region</text>

      {/* Column 1: on-prem */}
      <rect x="80" y="110" width="160" height="56" rx="10" fill="#0b1929" />
      <text x="160" y="135" textAnchor="middle" fontFamily="Raleway" fontSize="13" fontWeight="700" fill="#fff">Bancony Server</text>
      <text x="160" y="153" textAnchor="middle" fontFamily="Raleway" fontSize="11" fill="rgba(255,255,255,0.7)">in bank datacentre</text>

      <rect x="80" y="190" width="160" height="46" rx="10" fill="#fff" stroke="#cdd6e3" />
      <text x="160" y="218" textAnchor="middle" fontFamily="Raleway" fontSize="12" fontWeight="600" fill="#0b1929">Bank core / APIs</text>

      <rect x="80" y="252" width="160" height="46" rx="10" fill="#fff" stroke="#cdd6e3" />
      <text x="160" y="280" textAnchor="middle" fontFamily="Raleway" fontSize="12" fontWeight="600" fill="#0b1929">Bank IdP</text>

      {/* Column 2: bank cloud */}
      <rect x="400" y="110" width="160" height="56" rx="10" fill="#0b1929" />
      <text x="480" y="135" textAnchor="middle" fontFamily="Raleway" fontSize="13" fontWeight="700" fill="#fff">Bancony Server</text>
      <text x="480" y="153" textAnchor="middle" fontFamily="Raleway" fontSize="11" fill="rgba(255,255,255,0.7)">in bank's AWS/Azure</text>

      <rect x="400" y="190" width="160" height="46" rx="10" fill="#fff" stroke="#cdd6e3" />
      <text x="480" y="218" textAnchor="middle" fontFamily="Raleway" fontSize="12" fontWeight="600" fill="#0b1929">Bank core / APIs</text>

      <rect x="400" y="252" width="160" height="46" rx="10" fill="#fff" stroke="#cdd6e3" />
      <text x="480" y="280" textAnchor="middle" fontFamily="Raleway" fontSize="12" fontWeight="600" fill="#0b1929">Bank IdP</text>

      {/* Column 3: SaaS */}
      <rect x="720" y="110" width="160" height="56" rx="10" fill="#0b1929" />
      <text x="800" y="135" textAnchor="middle" fontFamily="Raleway" fontSize="13" fontWeight="700" fill="#fff">Bancony Server</text>
      <text x="800" y="153" textAnchor="middle" fontFamily="Raleway" fontSize="11" fill="rgba(255,255,255,0.7)">Bancony-operated, EU</text>

      <rect x="720" y="190" width="160" height="46" rx="10" fill="#fff" stroke="#cdd6e3" strokeDasharray="3 3" />
      <text x="800" y="208" textAnchor="middle" fontFamily="Raleway" fontSize="11" fontWeight="600" fill="#0b1929">VPN / private link</text>
      <text x="800" y="225" textAnchor="middle" fontFamily="Raleway" fontSize="10" fill="#777">→ bank core (still bank-side)</text>

      <rect x="720" y="252" width="160" height="46" rx="10" fill="#fff" stroke="#cdd6e3" />
      <text x="800" y="280" textAnchor="middle" fontFamily="Raleway" fontSize="12" fontWeight="600" fill="#0b1929">Bank IdP (federated)</text>

      {/* Footnote bar */}
      <rect x="40" y="334" width="880" height="2" fill="url(#boundary)" />
    </svg>
    <p className="diagram-caption">
      In on-prem and bank-cloud modes, customer data never leaves the bank's perimeter.
      A "no-egress" SaaS variant is available for the most security-conscious deployments.
    </p>
  </div>
);
